import React, { useEffect } from "react";

const ResoursePlanner: React.FC = () => {
  useEffect(()=>{
    window.open("https://planner.ganttic.com/","_blank")
  },[])
  return(
    <div>Planner</div>
  )
}
export default ResoursePlanner;